import React from "react";
import { makeStyles } from "tss-react/mui";

import { Box, BoxProps, Theme, useTheme } from "@mui/material";

interface LoadingIconProps {
    warning?: boolean;
    style?: React.CSSProperties;
}

export function LoadingIcon({ warning, style }: LoadingIconProps = {}): React.JSX.Element {
    const theme = useTheme();
    return (
        <i
            className="fa-solid fa-spinner fa-spin"
            style={{ color: warning ? theme.palette.emteria.warning : undefined, ...style }}
        />
    );
}

const useStyles = makeStyles()((theme: Theme) => ({
    loadingBox: {
        marginTop: theme.spacing(5),
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
    },
}));
interface LoadingBoxProps extends BoxProps {
    warning?: boolean;
}

export const LoadingBox = ({ warning, className, ...props }: LoadingBoxProps) => {
    const { classes } = useStyles();
    const theme = useTheme();

    return (
        <Box {...props} className={`${classes.loadingBox} ${className || ""}`}>
            <i className="fa-solid fa-spinner fa-spin" style={{ color: warning ? theme.palette.emteria.warning : undefined }} />
        </Box>
    );
};
